import type { IBrandConfig } from './types';

const COMERICA_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: 'policy/tou/idg-subbrand-privacy.md',
  termsOfService: 'policy/tou/idg-subbrand-terms.md',
  defaultBillingCategoryKey: 'identityguard_fi',
  copyRightEntity: 'Intersections LLC dba Pango.',
  carouselBanners: true,
  licensor: 'intersections',
  security: true,
  plan: true,
  finishSetup: false,
  adaChat: false,
  vaultProject: 'identityguard_watson',
  hasCustomerServiceSupport: true,
  secureUpload: true,
  accountDetails: true,
  dwEmailVerification: {
    adaChat: false,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday - Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    customerSupportTitle: {
      active: true,
      title: 'You can reach our customer care team:',
      availability:
        'Customer care representatives are available Monday - Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      active: true,
      customerSupport: true,
      availability: (
        <>
          Monday - Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    mail: {
      active: true,
      address: '250 Northern Ave., 3rd Floor Boston, MA 02210 United States',
      customerSupport: false,
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default COMERICA_BRAND_CONFIG;
